jQuery(document).ready(function ($) {
	$slider = $('.component-quote-slider>.component-inner');
	$slider.slick({
    dots: true,
    infinite: true, 
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
  });
});